import React from 'react';
import { observer } from 'mobx-react';
import { AntSelect } from 'controls/react/ant/ant-select/antSelect';
import { AntSelectPropsGeneric } from 'controls/react/ant/ant-select/types';
import { useRemoteListForSelect } from 'framework/api';
import { listRoles } from '../api';

export type RoleSelectorProps = AntSelectPropsGeneric<string[]> & {
	accountId?: string;
};

export const RoleSelector = observer((props: RoleSelectorProps) => {
	const { accountId, ...rest } = props;
	const remoteData = useRemoteListForSelect(listRoles({ accountId }), {
		sort: true,
		labelField: 'name',
		valueField: 'id',
	});

	return <AntSelect {...remoteData} {...rest} />;
});
